import React, { createContext, useContext, useState } from "react";

// Lets the Game Centre page publish its controls (view segments, period +
// event toggles) so the TOP site nav bar can render them. Provider wraps the
// whole Layout tree; the header reads `nav`, the game page sets it.
// ALSO carries a `pick` mode: when a page (e.g. Leaderboards Game Logs) wants
// the NAV 1 search box to become a player-only picker, it sets
// { active: true, onPick } — the global search then restricts to players,
// highlights purple, auto-opens, and calls onPick(player) instead of navigating.
const GameNavContext = createContext(null);

export function GameNavProvider({ children }) {
    const [nav, setNav] = useState(null);
    const [pick, setPick] = useState(null); // { active: bool, onPick: (player) => void }
    return <GameNavContext.Provider value={{ nav, setNav, pick, setPick }}>{children}</GameNavContext.Provider>;
}

export function useGameNav() {
    return useContext(GameNavContext) || { nav: null, setNav: () => {}, pick: null, setPick: () => {} };
}
